export default __webpack_public_path__ + "static/media/por.2a56690c.svg";